module.exports = __webpack_public_path__ + "media/tr_tr_s5_Reyhan.67aceec1.mp3";